const SOCIAL_LINKS = [
  { icon: 'mdi-telegram', url: 'https://t.me/issi_spirits', label: 'Telegram-канал ISSI' },
  { icon: 'mdi-vk', url: 'https://vk.ru/issi_spirits', label: 'Сообщество ISSI во «ВКонтакте»' },
];

export default {
  data() {
    return {
      socialLinks: SOCIAL_LINKS,
    };
  },
  computed: {
    footerText() {
      return this.$store.state.settings.footer_text;
    },
  },
};
